import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useNotifications from '../../hooks/useNotifications'
import { addUrlQueryParams, createAncestryUrl, getFrontendBaseUrl } from '../../util/UrlUtil'
import { getQueueFamily } from '../../services/QueuesService'
import { getName, getFieldValue } from '../../util/PersonUtil'

export default () => {}

const YAD_VASHEM_BASE_URL = 'https://collections.yadvashem.org/en/names/search-results'
const YAD_VASHEM_TAB_TARGET = 'yadVashemTabTarget'
const YAD_VASHEM_MESSAGE_TAB_TARGET = 'yadVashemMessageTabTarget'
const ANCESTRY_TAB_TARGET = 'ancestryTabTarget'

function initTab(currentWindow, url, target, focus = false) {
  if (!currentWindow[target] || currentWindow[target].closed) {
    currentWindow[target] = currentWindow.open(url, target)
  } else {
    currentWindow[target].location.href = url
  }
  if (focus) {
    currentWindow[target].focus()
  }
  return currentWindow[target]
}

function openYadVashemTab(person) {
  const { firstName, lastName } = getName(person)
  const birthYear = getFieldValue(person?.birth?.value?.date).match(/\d{4}/)?.[0] || ''

  const params = {
    s_year_birth_search: birthYear,
  }

  if (firstName !== '') {
    params.s_first_name_search_en = firstName
    params.t_first_name_search_en = 'yvSynonym'
  }

  if (lastName !== '') {
    params.s_last_name_search_en = lastName
    params.t_last_name_search_en = 'yvSynonym'
  }

  const url = addUrlQueryParams(YAD_VASHEM_BASE_URL, params)
  try {
    const yadVashemTab = initTab(globalThis.window, url, YAD_VASHEM_TAB_TARGET)
    return { tab: yadVashemTab, msg: 'OK', error: null }
  } catch (err) {
    return { tab: null, msg: 'Error opening Yad Vashem tab', error: err }
  }
}

function openAncestryTab(family) {
  try {
    const url = createAncestryUrl(family)
    const ancestryTab = initTab(globalThis.window, url, ANCESTRY_TAB_TARGET)
    return { tab: ancestryTab, msg: 'OK', error: null }
  } catch (err) {
    return { tab: null, msg: 'Error opening Ancestry tab', error: err }
  }
}

function openMessageDetailTab(url, target, focus = false) {
  try {
    const urlTab = initTab(globalThis.window, url, target, focus)
    return { tab: urlTab, msg: 'OK', error: null }
  } catch (err) {
    return { tab: null, msg: `Error opening message detail tab ${url}`, error: err }
  }
}

export function useQueues() {
  const { t } = useTranslation()
  const [queuesData, setQueuesData] = useState({})
  const notifications = useNotifications()

  function openTabs(message, url) {
    const errors = []
    // message detail tab
    const messageDetailTabResult = openMessageDetailTab(getFrontendBaseUrl() + url, YAD_VASHEM_MESSAGE_TAB_TARGET, true)
    if (messageDetailTabResult.error) {
      errors.push(messageDetailTabResult.msg)
    }
    getQueueFamily(message?.details?.personId)
      .then((family) => {
        const person = family.principal
        if (person) {
          // Yad vashem tab
          const yadVashemTabResult = openYadVashemTab(person)
          if (yadVashemTabResult.error) {
            errors.push(yadVashemTabResult.msg)
          }
          // ancestry tab
          const ancestryTabResult = openAncestryTab(family)
          if (ancestryTabResult.error) {
            errors.push(ancestryTabResult.msg)
          }
          if (errors.length > 0) {
            notifications.error(
              t('queues.errorOpeningTabs', 'Error opening one or more tabs: {errors}', { errors: errors.join(', ') })
            )
          }
        }
      })
      .catch((err) => {
        notifications.error(t('queues.errorOpeningYadVashemTab', 'Error opening Yad Vashem tabs'), err)
      })
  }

  return {
    openTabs, // opens all yad vashem tabs
    openYadVashemTab, // used to call from message detail, so we need to export this
    queuesData,
    setQueuesData,
  }
}
